module.exports = __webpack_public_path__ + "img/flowerPicture_resize.9bdb7bad.jpg";